import {connect} from '@gisatcz/ptr-state';

import Action from "../../../state/Action";
import Select from "../../../state/Select";

import presentation from './presentation';

const mapStateToProps = (state, ownProps) => {
    return {
        mode: Select.components.get(state, 'visualizations', 'riskAssessmentActiveSection'),
        feature: Select.specific.eo4sdDrrInsarMyanmar20.getSelectedFeature(state, 'risk-assessment-big', 'risk-assessment-zones-big'),
        road: Select.specific.eo4sdDrrInsarMyanmar20.getSelectedFeature(state, 'risk-assessment-big', 'risk-assessment-roads-big')
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(presentation);
